module.exports = __webpack_public_path__ + "img/chartIcon.3fe573f3.png";